import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1985f25a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price-chart-banner__content" }


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceChartBanner',
  emits: ["refresh", "close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const onClose = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_ot_banner = _resolveComponent("ot-banner")!

  return (_openBlock(), _createBlock(_component_ot_banner, {
    class: "price-chart-banner",
    variant: "warning"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.charting.restoreSavedCharts.banner.text')), 1),
        _createVNode(_component_x_button, {
          size: "3xs",
          variant: "text-like"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ot_icon, {
              class: "price-chart-banner__banner-icon",
              name: "refresh",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('refresh')))
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_x_button, {
        class: "price-chart-banner__banner-button price-chart-banner__banner-button--close",
        size: "3xs",
        variant: "text-like"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ot_icon, {
            class: "price-chart-banner__banner-icon",
            name: "close",
            onClick: onClose
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})